import React from 'react'
import { App } from './app/views'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { changeLanguage } from '~app/services'
import { getConfigByKey } from '~features/tenantConfig/services'

export default props => {
  const { t, i18n } = useTranslation()
  const [draft, setDraft] = React.useState(false)
  const [init, setInitApp] = React.useState(false)
  const dispatch = useDispatch()
  let defaultLgn = getConfigByKey('default_locale') || 'en'
  let language = JSON.parse(window.localStorage.getItem('persist:root'))
  React.useEffect(() => {
    setDraft(true)
    if (language) {
      language = JSON.parse(language.root)
      defaultLgn = language.language
    }

    if (!init) {
      dispatch(changeLanguage(defaultLgn))
    }
    setInitApp(true)
  }, [i18n.language])
  React.useEffect(() => {
    if (!draft) {
      return
    }
    setDraft(false)
  }, [draft])

  return !draft ? <App {...props} /> : null
  // return <App {...props} />
}
